import { render, staticRenderFns } from "./PublicProfileForm.vue?vue&type=template&id=47afafdd&"
import script from "./PublicProfileForm.vue?vue&type=script&lang=js&"
export * from "./PublicProfileForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports